import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import api from '~/store/api';
import type { ExternalTrial } from '~/store/trial/types';

import { trialsKeys } from './keys';

type UseTrialOptions = Omit<
  UseQueryOptions<ExternalTrial | undefined, Error, ExternalTrial | undefined, ReturnType<typeof trialsKeys.detail>>,
  'queryKey' | 'queryFn'
>;

export function useTrial(trialId: string | undefined, options?: UseTrialOptions) {
  const id = trialId?.trim() || '';

  return useQuery({
    ...options,
    queryKey: trialsKeys.detail(id),
    enabled: Boolean(id) && (options?.enabled ?? true),
    queryFn: () => api.trials.getTrial(id),
  });
}
